module.exports = __webpack_public_path__ + "img/riskArea_uncheck.710ff040.png";